import {create} from 'zustand';

export const useTittleContenidoStore = create((set) => ({
    tittleContenido: 'App TLS',
    setTittleContenido: (tittle: string) => set({tittleContenido: tittle}),
}));